// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oimvf","footer":"styles_footer__3yrcA","passCodeTooltip":"styles_passCodeTooltip__2qkR2"};